export const routeName = 'privacy-policy';
export const slugs: Record<string, string> = {
	en: 'privacy-policy',
	es: 'politica-de-privacidad',
	ca: 'politica-de-privacitat',
	eu: 'pribatutasun-politika',
	gl: 'politica-de-privacidade',
	it: 'informativa-sulla-privacy',
	pt: 'politica-de-privacidade',
};
export const sitemap = { changefreq: 'yearly', priority: '0.3', lastmod: '2026-02-24' };
